// TEXT/TITLE/DESCRIPTION/LINK_TEXT fields hold i18n message keys (resolved via `t()` at
// display time in useMobileBanner.ts / MobileBanner.vue), not literal copy — see
// i18n/locales/en/shell.json `shell.mobileBanner`. LEFT_PILL_DEFAULT/RIGHT_TEXT_DEFAULT
// are never rendered (MobileBanner.vue computes its own services pill text) — left as
// plain English since nothing displays them.
export const BANNER_CONSTANTS = {
  TELEGRAM: {
    URL: 'https://t.me/dubai_insiders_club',
    ICON: 'telegram-icon',
    TEXT: 'shell.mobileBanner.telegram.joinChannel',
  },

  PRELAUNCH: {
    TITLE: 'shell.mobileBanner.prelaunch.title',
    DESCRIPTION: 'shell.mobileBanner.prelaunch.description',
  },

  SERVICES: {
    TITLE: 'shell.mobileBanner.services.title',
    DESCRIPTION: 'shell.mobileBanner.services.description',
    LEFT_PILL_DEFAULT: '3 Services Used',
    RIGHT_TEXT_DEFAULT: 'Insider Level',
  },

  UPGRADE: {
    TEXT: 'shell.mobileBanner.upgrade.text',
    LINK_TEXT: 'shell.mobileBanner.upgrade.linkText',
  },
} as const;

export const BANNER_VARIANTS = {
  PRELAUNCH: 'prelaunch',
  SERVICES: 'services',
  TRAINING: 'training',
  DEFAULT: 'default',
} as const;

export const BANNER_COLORS = {
  PRELAUNCH_BG: '#FFE9C8',
  SERVICES_BG: '#F8F7F3',
  BUTTON_PRIMARY: '#2BABEE',
  BUTTON_HOVER: '#2396D1',
  BORDER: '#E7E7E8',
  BORDER_ACCENT: '#FFC56D',
  TEXT_PRIMARY: '#197BAE',
} as const;
